import { render, staticRenderFns } from "./startNode.vue?vue&type=template&id=29e7a440&scoped=true&"
import script from "./startNode.vue?vue&type=script&lang=js&"
export * from "./startNode.vue?vue&type=script&lang=js&"
import style0 from "./startNode.vue?vue&type=style&index=0&id=29e7a440&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e7a440",
  null
  
)

export default component.exports